import { render, staticRenderFns } from "./ManageDialog.vue?vue&type=template&id=270f838c&scoped=true"
import script from "./ManageDialog.vue?vue&type=script&lang=js"
export * from "./ManageDialog.vue?vue&type=script&lang=js"
import style0 from "./ManageDialog.vue?vue&type=style&index=0&id=270f838c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270f838c",
  null
  
)

export default component.exports